import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded'
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded'
import { fetchDashboardScopeOptions } from 'services/BpService'

const MOBILE = '768px'

const PerformanceScopePicker = ({ scope, onChange }) => {
  const [options, setOptions] = useState(null)
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    fetchDashboardScopeOptions()
      .then(res => setOptions(res?.data?.data || res?.data || null))
      .catch(() => {})
  }, [])

  useEffect(() => {
    if (!open) return
    const onDown = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', onDown)
    return () => document.removeEventListener('mousedown', onDown)
  }, [open])

  const pick = (type, id, label) => { onChange({ type, id, label }); setOpen(false) }

  return (
    <Wrap ref={ref}>
      <Btn type='button' onClick={() => setOpen(o => !o)} aria-expanded={open} aria-haspopup='listbox' title='Choose which sites to count'>
        <HomeWorkRoundedIcon style={{ fontSize: 16 }} />
        <Label>{scope.label}</Label>
        <ArrowDropDownRoundedIcon style={{ fontSize: 18 }} />
      </Btn>
      {open && (
        <Menu>
          <Item $active={scope.type === 'all'} onClick={() => pick('all', null, 'All Building Passports')}>All Building Passports</Item>
          {options?.portfolios?.length > 0 && <Group>Portfolios</Group>}
          {(options?.portfolios || []).map(p => (
            <Item key={`p-${p.id}`} $active={scope.type === 'portfolio' && scope.id === p.id} onClick={() => pick('portfolio', p.id, p.name)}>{p.name}</Item>
          ))}
          {options?.estates?.length > 0 && <Group>Estates</Group>}
          {(options?.estates || []).map(e => (
            <Item key={`e-${e.id}`} $active={scope.type === 'estate' && scope.id === e.id} onClick={() => pick('estate', e.id, e.name)}>{e.name}</Item>
          ))}
          {options?.buildingPassports?.length > 0 && <Group>Building Passports</Group>}
          {(options?.buildingPassports || []).map(b => (
            <Item key={`b-${b.id}`} $active={scope.type === 'bp' && scope.id === b.id} onClick={() => pick('bp', b.id, b.name)}>{b.name}</Item>
          ))}
        </Menu>
      )}
    </Wrap>
  )
}

export default PerformanceScopePicker

const Wrap = styled.div` position: relative; flex-shrink: 0; `
const Btn = styled.button`
  font: inherit; display: inline-flex; align-items: center; gap: 6px;
  min-height: 40px; padding: 8px 10px 8px 12px; border-radius: 10px; cursor: pointer;
  background: #f7f8fc; border: 1px solid #e4e6ee; color: #101828; font-weight: 700; font-size: 13px;
  &:hover { border-color: #cfd3e0; }
`
const Label = styled.span`
  max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;

  @media (max-width: ${MOBILE}) { max-width: 140px; }
`
const Menu = styled.div`
  position: absolute; top: calc(100% + 6px); right: 0; z-index: 40;
  width: 280px; max-height: 340px; overflow-y: auto; padding: 6px;
  background: #fff; border: 1px solid #e6e8f0; border-radius: 12px;
  box-shadow: 0 16px 40px rgba(16,24,40,0.16);

  @media (max-width: ${MOBILE}) {
    left: 0; right: auto;
    width: min(280px, calc(100vw - 48px));
    max-height: 60vh;
  }
`
const Group = styled.div`
  padding: 8px 10px 4px; font-size: 10px; font-weight: 800; letter-spacing: 0.07em;
  text-transform: uppercase; color: #98a2b3;
`
const Item = styled.button`
  font: inherit; display: block; width: 100%; text-align: left;
  padding: 8px 10px; border: none; border-radius: 8px; cursor: pointer;
  font-size: 13px; font-weight: ${({ $active }) => ($active ? 800 : 600)};
  color: ${({ $active }) => ($active ? '#33becc' : '#344054')};
  background: ${({ $active }) => ($active ? '#eef4ff' : 'transparent')};
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  &:hover { background: ${({ $active }) => ($active ? '#eef4ff' : '#f4f5f9')}; }
`
